import styled from 'styled-components';
import Headline from 'components/Headline/styles';
import {DashboardHeader} from 'components/DashboardHeader/styles';

// Builds on DashboardHeader so the top spacing on tablet and mobile matches the
// other pages.
export const FeedbackHeader = styled(DashboardHeader)`
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 35px;
`;

export const FeedbackTitle = styled(Headline)`
  margin: 0 0 4px;
`;

export const FeedbackSubtitle = styled.p`
  font-size: 17px;
  font-weight: 400;
  line-height: 134%;
  color: #000000;
  margin: 0;
`;

export const FeedbackHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const SummaryCardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 35px;
  padding-top: 42px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const SummaryCard = styled.div`
  background: #fff;
  border: 1px solid #ededf2;
  border-radius: 12px;
  padding: 23px 20px 18px 21px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SummaryCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SummaryCardIcon = styled.img`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
`;

export const SummaryCardTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #2f3d48;
`;

export const SummaryCardBody = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
`;

export const SummaryCardValue = styled.div`
  font-size: 42px;
  font-weight: 275;
  line-height: 1;
  color: #2f3d48;
`;

export const SummaryCardMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  text-align: right;
  color: #b3b9c2;
`;

export const SummaryCardMetaTitle = styled.span`
  font-size: 14px;
  font-weight: 700;
`;

export const SummaryCardMetaContent = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const FeedbackToolbar = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 25px;
  flex-wrap: wrap;
  border-bottom: 2px solid #d9d9d9;

  @media (max-width: 399px) {
    gap: 12px;
  }
`;

export const FeedbackTabs = styled.div`
  display: flex;
  align-items: stretch;
  gap: 28px;

  @media (max-width: 399px) {
    gap: 8px;
  }

  @media (max-width: 599px) {
    gap: 14px;
  }
`;

export const FeedbackTab = styled.button`
  position: relative;
  border: none;
  background: transparent;
  padding: 8px 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #2f3d48;
  cursor: pointer;
  transition: font-weight 0.15s;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2px;
    height: 2px;
    background: transparent;
  }

  &.isActive {
    font-weight: 700;
  }

  &.isActive::after {
    background: #2f3d48;
  }
`;

export const OrderTypeDropdown = styled.div`
  position: relative;

  @media (max-width: 767px) {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const OrderTypeTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  padding: 8px 0 12px;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.2px;
  color: #ff2d38;
  cursor: pointer;

  img {
    width: 12px;
    height: 12px;
    display: block;
  }
`;

export const OrderTypeMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 130px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 5px 10px 0 #00000033;
  padding: 6px;
  z-index: 10;
`;

export const OrderTypeMenuItem = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  border: none;
  background: transparent;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #2f3d48;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: #f3f4f6;
  }

  &.isActive {
    font-weight: 700;
  }
`;

export const ReviewFeed = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const EmptyReviewsMessage = styled.div`
  padding: 24px;
  text-align: center;
  color: #929cb9;
`;

export const ReviewCardOuter = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 24px;
`;

export const ReviewCardWrapper = styled.div`
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
  cursor: ${({$expandable}) => ($expandable ? 'pointer' : 'default')};
`;

export const ReviewBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 21px;
  @media (max-width: 640px) {
    gap: 8px;
  }
`;

export const ReviewTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const ReviewIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  margin-bottom: 8px;
`;

const AVATAR_BG = {
  positive: '#17c98133',
  negative: '#ff2d3833'
};

export const ReviewAvatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({$sentiment}) => AVATAR_BG[$sentiment] || '#f3f4f6'};
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ReviewIdentityText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ReviewName = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
  color: #000000;
`;

export const ReviewSubtitle = styled.span`
  font-size: 8px;
  font-weight: 400;
  line-height: 140%;
  color: #000000;
`;

const STAR_COLOR = {
  positive: '#17c981',
  negative: '#ff2d38'
};

const STAR_EMPTY_COLOR = {
  positive: '#17c98133',
  negative: '#ff2d3833'
};

export const ReviewStars = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: ${({$sentiment}) => STAR_COLOR[$sentiment] || '#17a673'};

  svg {
    width: 22px;
    height: 22px;
  }

  .star-empty {
    color: ${({$sentiment}) => STAR_EMPTY_COLOR[$sentiment] || '#e3e6eb'};
  }
`;

export const ReviewCommentWrapper = styled.div``;

export const ReviewComment = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: #000000;
  margin: 0;
`;

export const ReviewCommentInlineToggle = styled.button`
  display: inline;
  background: transparent;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  color: #ff2d38;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const ReviewCommentToggle = styled.button`
  background: none;
  border: none;
  padding: 4px 0 0;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  color: #ff2d38;
  cursor: pointer;
  align-self: flex-start;
  &:hover {
    text-decoration: underline;
  }
`;

export const ReviewBottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

export const ReviewDate = styled.span`
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  color: #2f3d48;
  display: inline-flex;
  align-items: center;
`;

export const ReviewMethodTag = styled.span`
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  color: #2f3d48;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: '';
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background-color: #2f3d48;
  }
`;

export const ReviewOrderType = styled.span`
  position: relative;
  top: 13px;
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
  flex-shrink: 0;
`;

export const ExpandedSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;

export const ExpandedSectionCard = styled.div`
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
`;

export const ExpandedSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 2px 20px;
  background: #d9d9d9;
  color: #2f3d48;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
`;

export const Subsection = styled.div`
  background: ${({$variant}) => ($variant === 'white' ? '#ffffff' : '#f7f7f7')};
  border-top: ${({$borderTop}) => ($borderTop ? '1px solid #d9d9d9' : 'none')};
  padding: ${({$borderTop}) => ($borderTop ? '20px 0' : '20px')};
  margin: ${({$borderTop}) => ($borderTop ? '0 20px' : 0)};
  @media (max-width: 640px) {
    padding: ${({$borderTop}) => ($borderTop ? '16px 0' : '16px')};
    margin: ${({$borderTop}) => ($borderTop ? '0 16px' : 0)};
  }
`;

export const SubsectionLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
  margin: 0 0 12px;
  &:not(:first-child) {
    margin-top: 16px;
  }
`;

export const DidYouContactInline = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const DidYouContactInlineLabel = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
  flex: 0 0 auto;
`;

export const ContactRow = styled.div`
  display: flex;
  gap: 8px;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #d5d8de;
  border-radius: 10px;
  padding: 10px 16px;
  min-width: 0;
`;

export const ContactItemIcon = styled.img`
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
`;

export const ContactItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const ContactItemLabel = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #2f3d48;
`;

export const ContactItemValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #2f3d48;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  display: block;
`;

export const ContactItemCopy = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #ff2d38;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  margin-left: auto;
  &:hover {
    text-decoration: underline;
  }
`;

export const DidYouContactRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 48px;
  @media (max-width: 600px) {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const DidYouContactItem = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #2f3d48;
  font-size: 14px;
  font-weight: 700;

  img {
    width: 18px;
    height: 18px;
    display: block;
  }
`;

export const OrderContextStrip = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f7f7f7;
  border-radius: 10px;
  padding: 14px 24px;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const OrderContextGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
  @media (max-width: 640px) {
    gap: 24px;
  }
`;

export const OrderContextItem = styled.div`
  display: flex;
  gap: 8px;
  font-size: 14px;
  color: #172751;
`;

export const OrderContextLabel = styled.span`
  font-weight: 700;
  color: #172751;
`;

export const OrderContextValue = styled.span`
  font-weight: 400;
  color: #172751;
`;

export const ItemsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;

  th,
  td {
    text-align: left;
    padding: 5.5px 46px 4.5px 0;
    font-size: 14px;
    color: #172751;
    white-space: nowrap;
    vertical-align: middle;
  }

  th:last-child,
  td:last-child {
    padding-right: 0;
  }

  thead tr {
    border-bottom: 1px solid #929cb9;
  }

  th {
    font-weight: 700;
  }

  td {
    font-weight: 400;
  }
`;

export const TableScrollWrapper = styled.div`
  overflow-x: auto;
  width: 100%;
`;

export const ClickableTableRow = styled.tr`
  cursor: pointer;

  &:hover td {
    background: #b3b9c2;
  }
`;

const STATUS_BAR_TEXT_COLOR = {
  needs_reply: '#ff2d38',
  emailed: '#2f3d48',
  called: '#2f3d48',
  skipped: '#2f3d48'
};

export const ReviewStatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 2px 20px;
  background: #d9d9d9;
  color: ${({$status}) => STATUS_BAR_TEXT_COLOR[$status] || '#2f3d48'};
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
`;

export const ReviewStatusBarChevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  img {
    width: 12px;
    height: 12px;
    display: block;
  }
`;

export const ExpandedBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 20px;
`;

export const OrderStrip = styled.div`
  background: #f3f4f6;
  border-radius: 8px;
  padding: 12px 16px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;

export const OrderStripCell = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
`;

export const OrderStripLabel = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
`;

export const OrderStripValue = styled.span`
  font-size: 13px;
  color: #4b5563;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const GrayPanel = styled.div`
  background: #f7f8fa;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const PanelDivider = styled.div`
  height: 1px;
  background: #ededf2;
`;

export const PanelSectionLabel = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
  display: block;
  margin-bottom: 10px;
`;

export const ContactBoxesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const ContactBox = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #ededf2;
  background: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  color: #1a1d23;
  cursor: pointer;
  transition: all 0.15s;
  min-width: 240px;

  &:hover {
    border-color: #d8dae3;
    background: #fafbfc;
  }

  &.isCopied {
    border-color: #17a673;
  }
`;

export const ContactBoxText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CopyIconRed = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #e63946;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ReplyTemplatesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  @media (max-width: 600px) {
    column-gap: 4px;
    row-gap: 8px;
  }
`;

export const ReplyTemplate = styled.button`
  border: 1px solid #b3b9c2;
  background: #fff;
  border-radius: 30px;
  padding: 0.5px 10px;
  font-size: 13px;
  font-weight: 400;
  line-height: 28px;
  color: #2f3d48;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;

  &::after {
    content: attr(data-label);
    display: block;
    font-weight: 700;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    white-space: nowrap;
  }

  &.isActive {
    border-color: #2f3d48;
    color: #2f3d48;
    font-weight: 700;
  }
`;

export const ReplyMessage = styled.p`
  margin: 0 0 15px;
  font-size: 14px;
  line-height: 1.5;
  color: #1a1d23;
  white-space: pre-wrap;
`;

export const CopyMessageButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: #17c981;
  color: #fff;
  border-radius: 999px;
  padding: 0 10px;
  font-size: 13px;
  font-weight: 700;
  line-height: 28px;
  cursor: pointer;
  transition: background 0.15s;

  img {
    width: 16px;
    height: 16px;
    display: block;
    filter: brightness(0) invert(1);
  }

  &:hover {
    background: #14b074;
  }

  &:disabled {
    background: #0d8a5b;
    cursor: default;
  }
`;

export const InlineTrackRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 24px;
  padding: 4px 4px 0;
`;

export const InlineTrackLabel = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1a1d23;
  margin-right: 8px;
`;

export const InlineTrackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  padding: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  cursor: pointer;
  transition: color 0.15s;

  svg {
    width: 18px;
    height: 18px;
    color: #1a1d23;
  }

  &:hover {
    color: #4b5563;

    svg {
      color: #4b5563;
    }
  }

  &.isActive {
    color: #17a673;

    svg {
      color: #17a673;
    }
  }
`;

export const ReplyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 999px;
  padding: 10px 20px;
  background-color: #ff2d38;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: #e5252f;
  }

  &:disabled {
    background-color: #f6a5a9;
    cursor: default;
  }
`;

export const CopyMessageSecondaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d5d8de;
  border-radius: 999px;
  padding: 10px 18px;
  background-color: #ffffff;
  color: #1a1d23;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f4f5f7;
  }

  &:disabled {
    color: #929cb9;
    border-color: #eef0f4;
    cursor: default;
  }

  &:disabled:hover {
    background-color: #ffffff;
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

export const ReplyActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

export const ReplyActionsHelper = styled.span`
  font-size: 13px;
  color: #6b7280;
  margin-left: 4px;
`;

export const ReplySentBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 21px;
  background-color: rgba(23, 201, 129, 0.15);
  color: #068954;
  font-size: 14px;
  font-weight: 500;

  strong {
    font-weight: 700;
  }
`;

export const ReplySentCheck = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  color: #068954;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ReplyModalContent = styled.div`
  padding: 24px 28px 28px;
`;

export const ReplyModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const ReplyModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1d23;
`;

export const ReplyModalField = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eef0f4;
`;

export const ReplyModalFieldLabel = styled.span`
  font-size: 13px;
  color: #6b7280;
`;

export const ReplyModalFieldValue = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #1a1d23;
  min-width: 0;
`;

export const ReplyModalHelper = styled.span`
  margin-left: auto;
  font-size: 12px;
  color: #6b7280;
`;

export const ReplyModalToChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 4px;
  background-color: #f4f5f7;
  border-radius: 999px;
`;

export const ReplyModalToChipAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #ff9aa2;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
`;

export const ReplyModalToChipEmail = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
`;

export const ReplyModalToChipLock = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const ReplyModalSubjectInput = styled.input`
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  padding: 4px 0;

  &.error {
    color: #ba0302;
  }
`;

export const ReplyModalTextareaWrapper = styled.div`
  margin: 20px 0 18px;

  textarea {
    background-color: #ffffff;
    border-color: #eef0f4;
  }
`;

export const ReplyModalActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 24px;
`;

export const SendReplyButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 0;
  border-radius: 999px;
  padding: 14px 32px;
  background-color: #ff2d38;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 24px 0 rgba(255, 45, 56, 0.35);
  transition: background-color 0.15s;

  &:hover {
    background-color: #e5252f;
  }

  &:disabled {
    background-color: #f6a5a9;
    box-shadow: none;
    cursor: default;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ReplyModalCancelButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  color: #6b7280;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    opacity: 60%;
  }
`;

export const PromoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 14px 0 12px;
`;

export const CreateDiscountCTA = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const CreateDiscountCTAIcon = styled.span`
  display: inline-flex;
  flex: none;
  color: #9ca3af;
`;

export const CreateDiscountCTAText = styled.span`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px 8px;
  min-width: 0;
`;

export const CreateDiscountCTAPrompt = styled.span`
  font-size: 13px;
  color: #6b7280;
`;

export const CreateDiscountCTALink = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #ff2d38;
  text-decoration: underline;
  white-space: nowrap;

  ${CreateDiscountCTA}:hover & {
    color: #d81b26;
  }
`;

export const ActivePromoPill = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  background: #fdf6d8;
  border: 1px solid #f0e2a8;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 14px;
`;

export const ActivePromoPillText = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 10px;
  flex: 1;
  min-width: 0;
`;

export const ActivePromoPillIcon = styled.span`
  display: inline-flex;
  flex: none;
  color: #db8d04;
`;

export const ActivePromoPillCode = styled.span`
  font-weight: 800;
  color: #000000;
  letter-spacing: 0.02em;
`;

export const ActivePromoPillMeta = styled.span`
  color: #4b5560;
  white-space: nowrap;
`;

export const ActivePromoPillNote = styled.span`
  color: #6b7280;
  white-space: nowrap;

  &::before {
    content: '\\00B7';
    margin-right: 6px;
    opacity: 0.7;
  }
`;

export const ActivePromoPillEdit = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
  padding: 0;
  font-size: 14px;
  font-weight: 700;
  color: #db8d04;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #b6771b;
  }
`;
